<div class="d-flex align-items-center kt-mat-alert  kt-mat-alert--{{ type }} {{type.toLowerCase()}}-container alert-container" role="alert">
  @if (showAlertIcon) {
    <div>
      @if (type.toLowerCase() === alertTypeEnum.WARNING.toLowerCase()) {
        <div class="icon warning-icon">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
      }
      @if (type.toLowerCase() === alertTypeEnum.ERROR.toLowerCase()) {
        <div class="icon error-icon">
          <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
        </div>
      }
      @if (type.toLowerCase() === alertTypeEnum.SUCCESS.toLowerCase()) {
        <div class="icon success-icon">
          <i class="fas fa-check-circle" aria-hidden="true"></i>
        </div>
      }
      @if (type.toLowerCase() === alertTypeEnum.INFO.toLowerCase()) {
        <div class="icon info-icon">
          <i class="fas fa-info-circle" aria-hidden="true"></i>
        </div>
      }
    </div>
  }

  <div class="kt-mat-alert__text">
    <ng-content></ng-content>
  </div>
  @if (showCloseButton) {
    <div class="kt-mat-alert__close ml-auto">
      <button
        [attr.aria-label]="'aria.close' | translate"
        type="button"
        mat-icon-button
        class="{{type.toLowerCase()}}"
        (click)="closeAlert()"
        >
        <mat-icon class="material-icons">clear</mat-icon>
      </button>
    </div>
  }
</div>
